// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2oje1","col":"styles_col__2ugk8"};